import styles from './index.module.css'

import React from 'react'

import { Box, Flex, Tooltip } from 'components/ds'

import { AppearsOnColumnFilter } from './appears-on-column-filter'

export const NEW_COLUMN_TOOLTIP =
  'Hover over the number to see what playlists a track appears in'

// Header for the Appears on column with a dot marking it as newly released and
// a filter control for the number of playlists a track appears on.
export const AppearsOnHeader = () => (
  <Flex align="center" gap="2" wrap="nowrap" className={styles.header}>
    Appears on
    <AppearsOnColumnFilter />
    <Tooltip content={NEW_COLUMN_TOOLTIP} delayDuration={0} maxWidth="250px">
      <Box className={styles.newDot} data-testid="appears-on-new-dot" />
    </Tooltip>
  </Flex>
)
